export default __webpack_public_path__ + "static/media/ART12.588a4ed6.jpg";